import CustomCard from "../../CustomCard";
import {
    IconDepartment,
    PersonOutlinedChip,
    PlusIconsOptions
} from "../../buttons/IconButtons";
import CustomTooltip from "../../CustomTooltip";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 04 de 05 de 2026
 */

const DepartmentTotalEmployeesCard = ({item, onAdd}) => {


    return (
        <>
            <CustomCard
                classes="w-100"
                classCard="card-border-8px"
                classContent={`background-shades-50 ${item?.disabled ? 'disable-card-item' : 'background-hover-shades-100' }`}
            >
                <div className="row align-items-center">
                    <div className={`col-10 pr-0`}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div><IconDepartment className="mr-8px mb-1" /></div>
                            <div className={`flex-grow-1 minw-0`}>
                                <CustomTooltip
                                    text={item?.fullName}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>

                        <div className="border-bottom-shades-300 my-2" />
                        <div className='row align-items-baseline justify-content-between '>
                            <div className={'col-12 pl-0'}>
                                <div className="d-flex align-items-center">
                                    <div><PersonOutlinedChip className="mr-8px mb-1" /></div>
                                    <div className={"flex-grow-1 minw-0"}>
                                        <CustomTooltip
                                            text={item?.totalEmployees}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-2'>
                        <div className={"d-flex justify-content-end"}>
                            <PlusIconsOptions
                                className={`plus-icons-options icon-color-shades-400`}
                                onClick={() => onAdd(item)}
                            />
                        </div>
                    </div>
                </div>
            </CustomCard>
        </>
    );

}

export default DepartmentTotalEmployeesCard
